export default __webpack_public_path__ + "static/media/user.f4af1a6e.svg";